export default __webpack_public_path__ + "static/kaiserstrasse_nord_friedberg-1b6b370aa16904df8f3f7c924e63ced6.jpg";